export type ReviewItem = {
  name: string;
  role: string;
  text: string;
};

export const REVIEWS: ReviewItem[] = [
  {
    name: "追剧三年的阿茶",
    role: "内容型读者",
    text: "每天下班就看吃瓜17的今日速递，新剧怎么选、这周大家在看什么都讲得很清楚，节奏快也不啰嗦。",
  },
  {
    name: "只爱看综艺的小Q",
    role: "综艺爱好者",
    text: "名场面盘点这块很对我的胃口，省得我自己翻好几遍，看完文字版再去补正片，观感好很多。",
  },
  {
    name: "周末常去现场的Luna",
    role: "演出观众",
    text: "巡演和音乐节的资讯整理得挺及时，交通和抢票攻略也实用，帮我少踩了不少坑。",
  },
  {
    name: "刚学会看热搜的老王",
    role: "普通用户",
    text: "那篇热梗小词典我直接收藏了，很多词终于看懂了，跟年轻人聊天也没那么费劲了。",
  },
];